import axios from 'axios';

const request = () => window.axios || axios;

const buildBasePath = accountId =>
  `/api/v1/accounts/${accountId}/integrations/woocommerce`;

export const fetchWooCommerceState = accountId =>
  request().get(buildBasePath(accountId));

export const authorizeWooCommerce = (accountId, payload) =>
  request().post(`${buildBasePath(accountId)}/auth`, payload);

export const saveWooCommercePreferences = (accountId, payload) =>
  request().patch(`${buildBasePath(accountId)}/preferences`, payload);

export const fetchWooCommerceOrders = (accountId, contactId) =>
  request().get(`${buildBasePath(accountId)}/orders`, {
    params: { contact_id: contactId },
  });

export const fetchWooCommerceOrderDetails = (
  accountId,
  orderId,
  params = {}
) =>
  request().get(`${buildBasePath(accountId)}/order_details/${orderId}`, {
    params,
  });

export const fetchWooCommerceAllOrders = (accountId, params = {}) =>
  request().get(`${buildBasePath(accountId)}/all_orders`, { params });

export const fetchWooCommerceAbandonedCheckouts = (accountId, params = {}) =>
  request().get(`${buildBasePath(accountId)}/abandoned_checkouts`, { params });
